<template>
  <div class="main">
    <GoBack :name="`邀请好友`" :type="1" :path="`/mobile/home`"></GoBack>
    <!-- 背景 -->
    <img class="bg3" src="@/assets/mobile/image/home/bg3.png" />

    <div class="step-box">
      <div class="step-item" v-for="(item, index) in list" :key="item.name1">
        <div class="name-box">
          <img :src="item.url" />
          <div class="name1">{{ item.name1 }}</div>
          <div class="name2">{{ item.name2 }}</div>
        </div>
        <img
          class="step-arrow"
          v-if="index < 2"
          src="@/assets/mobile/image/home/step-arrow.png"
        />
      </div>
    </div>
    <div class="content">
      <!-- 我的邀请 -->
      <div class="content1">
        <img
          class="content-bg"
          src="@/assets/mobile/image/home/invitation2.png"
        />
        <!-- 已邀好友 -->
        <div class="my-box1">
          <div class="my-box1-content">
            <div class="number">
              <span>{{ friendCount }}</span
              >人
            </div>
            <div class="name">已邀好友</div>
          </div>
          <div class="my-box1-content">
            <div class="number">
              <span>{{ totalPoints }}</span
              >元
            </div>
            <div class="name">赚取奖励</div>
          </div>
        </div>
        <!-- 邀请榜单 -->
        <div class="my-box2">
          <div class="my-box2-left"></div>
          <div class="name">邀请榜单</div>
          <div class="my-box2-right"></div>
        </div>
        <div class="list-box">
          <div class="list-herder">
            <div class="list-left">
              <div class="left1">排名</div>
              <div class="left2">用户ID</div>
            </div>
            <div class="list-right">为我赚得</div>
          </div>
          <div
            class="list-item-box"
            @scroll="handleScroll"
            ref="scrollContainer"
          >
            <div
              class="list-item"
              v-for="(item, index) in tableData2"
              :key="index"
            >
              <div class="list-left">
                <div class="left1">
                  <img
                    v-if="index + 1 <= 3"
                    :src="
                      require(`@/assets/mobile/image/home/no${index + 1}.png`)
                    "
                  />
                  <span v-else>{{ index + 1 }}</span>
                </div>
                <div class="left2">
                  <img :src="item.avatarUrl" />
                  <span>{{ item.phone }}</span>
                </div>
              </div>
              <div class="list-right">{{ item.contribution }}</div>
            </div>
            <div class="flag" v-if="!flag && tableData2.length !== 0">
              触底加载更多
            </div>
            <div class="flag" v-if="flag && tableData2.length !== 0">
              已经到底了~
            </div>
            <van-empty v-if="tableData2.length === 0" description="暂无数据" />
          </div>
        </div>
      </div>
      <!-- 邀请方式 -->
      <div class="content2">
        <img
          class="content-bg"
          src="@/assets/mobile/image/home/invitation3.png"
        />

        <div class="title">邀请方式一</div>
        <div class="fs-box">
          <div class="left">{{ Url }}</div>
          <button class="btn" @click="copyText">一键复制</button>
        </div>
        <div class="title">邀请方式二</div>

        <canvas id="canvas" v-show="!imgshow" class="code"></canvas>
        <img class="code" v-show="imgshow" :src="img" />
        <div class="center">（我们将为您生成专属二维码下载发给好友）</div>
      </div>
      <!-- 活动说明 -->
      <div class="content3">
        <img
          class="content-bg"
          src="@/assets/mobile/image/home/invitation1.png"
        />

        <p class="p-top">
          1.通过推广链接、二维码、微信、微博等方式邀请好友注册速调吧。
        </p>
        <p>
          2.您的好友第一次完成调查，您将立即获得一次
          性的2元推荐奖励（包含：k调查、Y调查、G调查
          P调查（S调查除外）），同时您的好友今后每完成一次调查，您都可获得20%的提成。例如：您推荐好友“小调”完成注册速调吧，“小调”第一次完成一份30元的调查，您可以获得2元奖励+6元的提成奖励。
        </p>
        <p>
          3.如果您的好友超过6个月没有参与任何问卷，为避免资源闲置，账户将会视为休眠用户，并与您断开好友关系，您也无法获得奖励。
        </p>
        <p>
          4.活动日期：2023年1月1至2023年12月31日。注意：活动期间内奖励翻倍，活动结束后奖励恢复正常。
        </p>
      </div>
    </div>
  </div>
</template>
<script>
import GoBack from "@/components/goBack";
import {
  getFriends,
  getRecommendationSummary,
  getAccount,
  getWeChatAuthWechatUrl,
  getWeChatCallback,
} from "@/api/mobile";
import QRCode from "qrcode";
import { copyText, generateUUID } from "@/utils/replace";
export default {
  data() {
    return {
      list: [
        {
          name1: "分享链接",
          name2: "给您好友",
          url: require("@/assets/mobile/image/home/step1.png"),
        },
        {
          name1: "好友注册",
          name2: "成为会员",
          url: require("@/assets/mobile/image/home/step2.png"),
        },
        {
          name1: "好友赚钱",
          name2: "你得奖励",
          url: require("@/assets/mobile/image/home/step3.png"),
        },
      ],
      friendCount: 0,
      totalPoints: 0,
      flag: false,
      page2: 1,
      size2: 10,
      tableData2: [],
      img: null,
      imgshow: false,
      Url: null,
      weixinFlag: false,
    };
  },
  methods: {
    async getFriends(type) {
      if (type) {
        this.page2 = type;
        this.flag = false;
        this.tableData2 = [];
      }

      if (this.flag) {
        return;
      }
      await getFriends({
        page: this.page2,
        size: this.size2,
      }).then((res) => {
        if (res.code === 200) {
          if (res.data.list.length > 0) {
            this.tableData2 = this.tableData2.concat(res.data.list);
            if (res.data.list.length === 10) {
              this.page2++;
            } else {
              this.flag = true;
            }
          }
        }
      });
    },
    async getRecommendationSummary() {
      await getRecommendationSummary().then((res) => {
        if (res.code === 200) {
          this.friendCount = res.data.friendCount;
          this.totalPoints = res.data.totalPoints;
        }
      });
    },
    handleScroll(e) {
      const container = this.$refs.scrollContainer;
      // 检查是否接近底部
      console.log(
        container.scrollTop + container.clientHeight,
        container.scrollHeight
      );

      if (
        container.scrollTop + container.clientHeight >=
        container.scrollHeight - 1
      ) {
        // 触底逻辑，例如加载更多数据
        console.log("触底");
        this.getFriends();
      }
    },
    copyText() {
      copyText(this.Url).then((res) => {
        if (res === "复制成功") {
          this.$toast("复制成功");
        } else {
          this.$toast("复制失败");
        }
      });
    },
  },
  components: { GoBack },

  async mounted() {
    //微信自动登录
    if (!localStorage.getItem("token")) {
      if (!this.$route.query.code) {
        this.weixinFlag = true;
        let state = generateUUID();
        let redirectUrl = `https://www.aidajuan.com` + this.$route.path;
        await getWeChatAuthWechatUrl({
          redirectUrl,
          state,
        }).then((res) => {
          if (res.code === 200) {
            window.location.href = res.data;
          }
        });
      } else {
        await getWeChatCallback({
          code: this.$route.query.code,
          state: this.$route.query.state,
        }).then(async (res) => {
          if (res.code === 200) {
            localStorage.setItem("token", res.data.token);
            this.weixinFlag = false;
          }
        });
      }
    }
    if (this.weixinFlag) {
      return;
    }

    if (localStorage.getItem("userInfo")) {
      this.userInfo = JSON.parse(localStorage.getItem("userInfo"));
      this.$store.commit("changeUserInfo", this.userInfo);
    } else {
      await getAccount().then((res) => {
        if (res.code === 200) {
          this.userInfo = res.data;
          this.$store.commit("changeUserInfo", this.userInfo);
          localStorage.setItem("userInfo", JSON.stringify(res.data));
        }
      });
    }

    await this.getFriends();
    await this.getRecommendationSummary();

    let canvas = document.getElementById("canvas");

    this.Url =
      process.env.VUE_APP_SERVER +
      "register" +
      `?refer=${this.userInfo.recommendedCode}`;
    QRCode.toCanvas(canvas, this.Url, { width: 194, height: 192 }, (error) => {
      if (error) console.error(error);
    });

    this.img = canvas.toDataURL("image/png");
    this.imgshow = true;
  },
};
</script>
<style lang="scss" scoped>
.flag {
  text-align: center;
  color: #999;
  font-size: 14px;
}
.main {
  // min-height: 100vh;
  background: linear-gradient(180deg, #ff3815 0%, #ffeee2 27%, #fff9f5 100%);
  width: 100%;
  position: relative;
  padding-bottom: 8.54vw;
  .bg3 {
    width: 100%;
    position: absolute;
    top: 0;
    z-index: 1;
  }
  .step-box {
    position: absolute;
    width: 88vw;
    height: 29.33vw;
    background: #fffbf5;
    box-shadow: inset 0.8vw 0.8vw 1.6vw 0.26vw #fff5e5;
    border-radius: 0vw 0vw 2.13vw 2.13vw;
    z-index: 2;
    top: 69.33vw;
    left: 6vw;
    display: flex;
    align-items: center;
    justify-content: center;
    .step-item {
      display: flex;
      align-items: center;
      .name-box {
        display: flex;
        flex-direction: column;
        align-items: center;
        font-size: 2.66vw;
        color: #232323;
        img {
          width: 9.6vw;
          height: 9.6vw;
        }
        .name1 {
          margin-top: 1.06vw;
        }
        .name2 {
          margin-top: 0.54vw;
        }
      }
      .step-arrow {
        margin: 0 8vw 0 8vw;
      }
    }
  }
  .content {
    position: relative;
    padding-top: 95vw;
    z-index: 2;
    width: 88vw;
    margin-left: 6vw;
    .content1 {
      width: 100%;
      background: #ffffff;
      box-shadow: inset 0vw 0.8vw 2.13vw 0.26vw rgba(255, 158, 0, 0.08);
      border-radius: 2.13vw 2.13vw 2.13vw 2.13vw;
      padding-bottom: 5.86vw;
      margin-top: 3vw;
      .my-box1 {
        display: flex;
        justify-content: space-between;
        margin: 2.66vw 0 3.2vw 0;
        .my-box1-content {
          margin: 0 10vw;
          display: flex;
          flex-direction: column;
          align-items: center;
          .number {
            color: #232323;
            font-size: 3.73vw;
            span {
              font-size: 9.6vw;
              font-weight: bolder;
              margin-right: 2.13vw;
            }
          }
          .name {
            font-size: 3.73vw;
            color: #232323;
            margin-top: 1.06vw;
          }
        }
      }
      .my-box2 {
        display: flex;
        justify-content: center;
        align-items: center;
        margin-bottom: 5.33vw;
        .my-box2-left {
          width: 32.13vw;
          height: 0.26vw;
          background: linear-gradient(
            270deg,
            #ffa200 0%,
            rgba(255, 162, 0, 0.15) 100%
          );
        }
        .my-box2-right {
          width: 32.13vw;
          height: 0.26vw;
          background: linear-gradient(
            117deg,
            #ffa200 0%,
            rgba(255, 162, 0, 0) 100%
          );
        }
        .name {
          font-size: 3.73vw;
          color: #ff7f00;
          margin: 0 2.93vw;
        }
      }
      .list-box {
        width: 83.2vw;
        background: #fff7f2;
        border-radius: 1.06vw 1.06vw 1.06vw 1.06vw;
        margin-left: 2.4vw;
        padding: 3.2vw;
        padding-bottom: 5.33vw;
        box-sizing: border-box;
        font-size: 3.2vw;
        color: #232323;
        .list-herder {
          display: flex;
          justify-content: space-between;
          margin-bottom: 2.66vw;
          .list-left {
            display: flex;
            .left1 {
              width: 6.93vw;
              text-align: center;
              margin-right: 7.73vw;
            }
          }
        }
        .list-item-box {
          height: 100vw;
          overflow: auto;
          .list-item {
            display: flex;
            justify-content: space-between;
            margin-bottom: 5.33vw;
            align-items: center;
            .list-left {
              display: flex;
              .left1 {
                width: 6.93vw;
                text-align: center;
                margin-right: 7.73vw;
                display: flex;
                align-items: center;
                img {
                  width: 6.93vw;
                  height: 6.93vw;
                }
              }
              .left2 {
                display: flex;
                align-items: center;
                img {
                  width: 8vw;
                  height: 8vw;
                  border-radius: 4vw;
                  margin-right: 3.73vw;
                }
              }
            }
          }
        }
        .list-item:last-child {
          margin-bottom: 0;
        }
      }
    }
    .content2 {
      width: 100%;
      background: #ffffff;
      box-shadow: inset 0vw 0.8vw 2.13vw 0.26vw rgba(255, 158, 0, 0.08);
      border-radius: 2.13vw 2.13vw 2.13vw 2.13vw;
      margin-top: 4.8vw;
      padding-left: 4.26vw;
      padding-right: 4.26vw;
      padding-bottom: 5.86vw;
      box-sizing: border-box;
      color: #232323;
      .title {
        font-size: 3.73vw;
        margin-top: 6.4vw;
      }
      .fs-box {
        width: 100%;
        height: 11.2vw;
        background: #fff7f2;
        border-radius: 1.06vw 1.06vw 1.06vw 1.06vw;
        margin-top: 3.73vw;
        box-sizing: border-box;
        display: flex;
        align-items: center;
        .left {
          width: 100%;
          margin-left: 2.13vw;
          font-size: 3.2vw;

          overflow: hidden; /* 确保超出容器的内容被裁剪 */
          white-space: nowrap; /* 确保文本在一行内显示 */
          text-overflow: ellipsis; /* 超出部分显示省略号 */
        }
        .btn {
          flex-shrink: 0;
          padding: 0;
          margin: 0;
          border: none;
          width: 18.993vw;
          height: 6.66vw;
          background: linear-gradient(95deg, #ffa200 0%, #ff6017 100%);
          border-radius: 3.46vw 3.46vw 3.46vw 3.46vw;
          color: #fff;
          margin-right: 1.6vw;
          font-size: 3.46vw;
          margin-left: 2.66vw;
        }
      }
      .code {
        width: 29.86vw;
        height: 29.86vw;
        transform: translateX(-50%);
        position: relative;
        left: 50%;
        margin-top: 3.73vw;
      }
      .center {
        text-align: center;
        font-size: 3.2vw;
        margin-top: 5.33vw;
      }
    }
    .content3 {
      width: 100%;
      background: #ffffff;
      box-shadow: inset 0vw 0.8vw 2.13vw 0.26vw rgba(255, 158, 0, 0.08);
      border-radius: 2.13vw 2.13vw 2.13vw 2.13vw;
      padding: 0 3.2vw 4.8vw 3.46vw;
      box-sizing: border-box;
      margin-top: 5.86vw;
      p {
        margin-bottom: 3.73vw;
        color: #232323;
        font-size: 3.73vw;
        line-height: 5.33vw;
      }
      .p-top {
        margin-top: 5.86vw;
      }
    }
    .content-bg {
      width: 50.66vw;
      height: 8.53vw;
      position: relative;
      left: 50%;
      transform: translateX(-50%);
    }
  }
}
</style>